var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : 'button',{tag:"component",class:{
    primary: _vm.primary,
    primaryBorder: _vm.primaryBorder,
    disabled: _vm.disabled,
    confirm: _vm.confirm,
    back: _vm.back,
    marginRight: _vm.marginRight,
    facebook: _vm.facebook,
    marginTop: _vm.marginTop,
    secondary: _vm.secondary,
    secondaryBorder: _vm.secondaryBorder,
    dark: _vm.dark,
    alignLeft: _vm.alignLeft,
    alignRight: _vm.alignRight,
    bigger: _vm.bigger
    },attrs:{"to":_vm.to,"type":"button"},on:{"click":_vm.next}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }